import { InjectionToken } from '@angular/core';

export const SSR_URL = new InjectionToken<string>('SSR_URL');
